import { useEffect } from 'react';
import Contact from './company/Contact';
import { LOCALSTORAGE_KEY } from '@/constants/calendar';
import NavigationBar from '@/components/navigationBar/NavigationBar';
import Product from './products/Product';
import Resources from './technology/Resources';
import Technology from './technology/Technology';
import Team from './team/Team';
import Footer from './Footer';
import CombinedHomePage from './CombinedHomePage';
import Home from './Home';
import Partners from './partners/Partners';

const NewBody = () => {
  useEffect(() => {
    if (localStorage.getItem(LOCALSTORAGE_KEY)) {
      const page = document.getElementById('Contact');
      page && page.scrollIntoView({ behavior: 'smooth' });
      localStorage.removeItem(LOCALSTORAGE_KEY);
    }
  }, []);

  return (
    <>
      <NavigationBar />
      <Home />
      <CombinedHomePage />
      <Product />
      <Technology />
      <Resources />
      <Team />
      <Partners />
      <Contact />
      <Footer />
    </>
  );
};

export default NewBody;
